/* Naht & Leinen – Inhaltsseiten (Team D): Video-Dialog, Bewertungsfilter, Händlerliste, Formularprüfung, Artikelschritte. */
(function () {
  'use strict';

  /* Video im Dialog (Über uns: „Lern uns kennen“) */
  function video(knopf) {
    if (knopf.dataset.nlBereit) return;
    knopf.dataset.nlBereit = '1';
    var dialog = document.getElementById(knopf.getAttribute('aria-controls'));
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var film = dialog.querySelector('video');
    knopf.addEventListener('click', function () {
      dialog.showModal();
      if (film) { try { film.play(); } catch (e) {} }
    });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    var zu = dialog.querySelector('[data-nl-seite-zu]');
    if (zu) zu.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('close', function () { if (film) film.pause(); knopf.focus(); });
  }

  /* Filter für Judge.me-Bewertungen (Seite Bewertungen) */
  function kategorie(eintrag) {
    var bild = eintrag.querySelector('.jdgm-carousel-item__product-image');
    var titel = eintrag.querySelector('.jdgm-carousel-item__product-title');
    var name = ((bild && bild.getAttribute('alt')) || (titel && titel.textContent) || '').toLowerCase();
    if (name.indexOf('beau') > -1) return 'beaubag';
    if (name.indexOf('bunbag') > -1 || name.indexOf('sparset') > -1) return 'bunbag';
    return 'weitere';
  }

  function filter(leiste) {
    if (leiste.dataset.nlBereit) return;
    leiste.dataset.nlBereit = '1';
    var sektion = leiste.closest('.nl-seite-bew');
    var status = sektion && sektion.querySelector('[data-nl-seite-filter-status]');
    var knoepfe = Array.prototype.slice.call(leiste.querySelectorAll('[data-filter]'));
    function anwenden(wert) {
      var eintraege = sektion ? sektion.querySelectorAll('.jdgm-carousel-item') : [];
      var sichtbar = 0;
      Array.prototype.forEach.call(eintraege, function (e) {
        var zeigen = wert === 'alle' || kategorie(e) === wert;
        e.hidden = !zeigen;
        if (zeigen) sichtbar += 1;
      });
      knoepfe.forEach(function (k) { k.setAttribute('aria-pressed', k.dataset.filter === wert ? 'true' : 'false'); });
      if (sektion && wert !== 'alle') sektion.classList.add('is-offen');
      if (status) status.textContent = sichtbar === 1 ? '1 Bewertung' : sichtbar + ' Bewertungen';
    }
    knoepfe.forEach(function (k) { k.addEventListener('click', function () { anwenden(k.dataset.filter); }); });
  }

  /* Bewertungen: Produktbilder laden, die Judge.me nur im sichtbaren Karussellteil nachlädt; mobil alle zeigen */
  function bewertungen(sektion) {
    function bilder() {
      Array.prototype.forEach.call(sektion.querySelectorAll('img.jdgm-carousel-item__product-image[data-src]'), function (img) {
        if (!img.getAttribute('src')) {
          img.setAttribute('src', img.getAttribute('data-src'));
          if (img.getAttribute('data-src-retina')) img.setAttribute('srcset', img.getAttribute('data-src') + ' 1x, ' + img.getAttribute('data-src-retina') + ' 2x');
          img.setAttribute('loading', 'lazy');
        }
      });
    }
    bilder();
    setTimeout(bilder, 1500);
    if (sektion.dataset.nlBereit) return;
    sektion.dataset.nlBereit = '1';
    var alle = sektion.querySelector('[data-nl-seite-alle]');
    if (alle) alle.addEventListener('click', function () {
      sektion.classList.add('is-offen');
      var fuenfter = sektion.querySelectorAll('.jdgm-carousel-item')[4];
      if (fuenfter) { fuenfter.setAttribute('tabindex', '-1'); fuenfter.focus(); }
    });
  }

  /* Händlerliste mobil aufklappen */
  function mehr(knopf) {
    if (knopf.dataset.nlBereit) return;
    knopf.dataset.nlBereit = '1';
    var liste = document.getElementById(knopf.getAttribute('aria-controls'));
    if (!liste) return;
    knopf.addEventListener('click', function () {
      liste.classList.add('is-offen');
      knopf.setAttribute('aria-expanded', 'true');
      knopf.hidden = true;
      var erster = liste.querySelectorAll('.nl-seite-haendler__eintrag')[6];
      var ziel = erster && erster.querySelector('a, div');
      if (ziel && ziel.tagName === 'A') ziel.focus();
    });
  }

  /* Kontaktformular: Fehler direkt am Feld */
  function formular(form) {
    if (form.dataset.nlBereit) return;
    form.dataset.nlBereit = '1';
    var felder = Array.prototype.slice.call(form.querySelectorAll('[data-nl-pruefen]'));
    function fehler(feld, zeigen) {
      var meldung = document.getElementById(feld.getAttribute('data-nl-pruefen'));
      if (meldung) meldung.hidden = !zeigen;
      if (zeigen) feld.setAttribute('aria-invalid', 'true'); else feld.removeAttribute('aria-invalid');
    }
    form.addEventListener('submit', function (e) {
      var erstes = null;
      felder.forEach(function (feld) {
        var ok = feld.type === 'checkbox' ? feld.checked : feld.checkValidity();
        fehler(feld, !ok);
        if (!ok && !erstes) erstes = feld;
      });
      if (erstes) { e.preventDefault(); erstes.focus(); }
    });
    felder.forEach(function (feld) {
      var ereignis = feld.type === 'checkbox' ? 'change' : 'input';
      feld.addEventListener(ereignis, function () {
        var ok = feld.type === 'checkbox' ? feld.checked : feld.checkValidity();
        if (ok) fehler(feld, false);
      });
    });
  }

  /* Artikel: „1. Titel“-Zwischenüberschriften als nummerierte Schritte */
  function schritte(inhalt) {
    if (inhalt.dataset.nlBereit) return;
    inhalt.dataset.nlBereit = '1';
    Array.prototype.forEach.call(inhalt.querySelectorAll('h3'), function (h) {
      var treffer = /^\s*(\d{1,2})\.\s+/.exec(h.textContent);
      if (!treffer) return;
      var knoten = h.firstChild;
      while (knoten && knoten.nodeType !== 3) knoten = knoten.firstChild;
      if (!knoten || knoten.nodeValue.indexOf(treffer[1] + '.') === -1) return;
      knoten.nodeValue = knoten.nodeValue.replace(/^\s*\d{1,2}\.\s+/, '');
      var nr = document.createElement('span');
      nr.className = 'nl-seite-schritt__nr';
      nr.setAttribute('aria-hidden', 'true');
      nr.textContent = treffer[1];
      var sr = document.createElement('span');
      sr.className = 'nl-unsichtbar';
      sr.textContent = treffer[1] + '. ';
      h.insertBefore(sr, h.firstChild);
      h.insertBefore(nr, h.firstChild);
      h.classList.add('nl-seite-schritt');
    });
  }

  function start(scope) {
    var s = scope || document;
    Array.prototype.forEach.call(s.querySelectorAll('[data-nl-seite-video]'), video);
    Array.prototype.forEach.call(s.querySelectorAll('[data-nl-seite-filter]'), filter);
    Array.prototype.forEach.call(s.querySelectorAll('.nl-seite-bew'), bewertungen);
    Array.prototype.forEach.call(s.querySelectorAll('[data-nl-seite-mehr]'), mehr);
    Array.prototype.forEach.call(s.querySelectorAll('[data-nl-seite-formular]'), formular);
    Array.prototype.forEach.call(s.querySelectorAll('[data-nl-seite-schritte]'), schritte);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(document); });
  else start(document);
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
